import React from 'react';
import { TableRow } from '@material-ui/core';
import { useIntl } from 'react-intl';
import { StyledTableCellProps as StyledTableCell, StyledTooltip } from '../../commons/utils/TableStyles';
import Security from '../../commons/security/Security.js';

const EquipamientoGridRow = ({ equipamiento, columnas, onVer, onEditar }) => {
	const intl = useIntl();

	return (
		<TableRow>
			<StyledTableCell className={equipamiento.activo ? 'status-green' : 'status-red'} />
			<StyledTableCell show={columnas.esVisible('identificador')}>{equipamiento.identificador}</StyledTableCell>
			<StyledTableCell show={columnas.esVisible('tipo')}>{equipamiento.tipo}</StyledTableCell>
			<StyledTableCell show={columnas.esVisible('marca')}>{equipamiento.marca}</StyledTableCell>
			<StyledTableCell show={columnas.esVisible('modelo')}>{equipamiento.modelo}</StyledTableCell>
			<StyledTableCell show={columnas.esVisible('vehiculo')}>{equipamiento.vehiculo}</StyledTableCell>
			<StyledTableCell align="center">
				<div className="d-inline-flex">
					{Security.hasPermission('EQUIPAMIENTO_VISUALIZAR') && (
						<StyledTooltip title={intl.formatMessage({ id: 'equipamientoGrid.columns_action.button_title_ver', defaultMessage: 'Ver' })} arrow placement="top">
							<button type="button" className="action view btn btn-sm btn-icon btn-dt-grid text-success" aria-label={intl.formatMessage({ id: 'equipamientoGrid.columns_action.button_title_ver', defaultMessage: 'Ver' })} onClick={() => onVer(equipamiento)}>
								<i className="fa fa-search fa-xs" />
							</button>
						</StyledTooltip>
					)}
					{Security.hasPermission('MOVILES_MODIFICAR_EQUIPAMIENTO') && (
						<StyledTooltip title={intl.formatMessage({ id: 'equipamientoGrid.columns_action.button_title_editar', defaultMessage: 'Editar' })} arrow placement="top">
							<button type="button" className="action edit btn btn-sm btn-icon btn-dt-grid text-success" aria-label={intl.formatMessage({ id: 'equipamientoGrid.columns_action.button_title_editar', defaultMessage: 'Editar' })} onClick={() => onEditar(equipamiento)}>
								<i className="fa fa-pencil fa-xs" />
							</button>
						</StyledTooltip>
					)}
				</div>
			</StyledTableCell>
		</TableRow>
	);
};

export default EquipamientoGridRow;
